export default "__VITE_ASSET__BHt1Vwsv__"